import { render, staticRenderFns } from "./FacilityBim.vue?vue&type=template&id=596be389&scoped=true&"
import script from "./FacilityBim.vue?vue&type=script&lang=js&"
export * from "./FacilityBim.vue?vue&type=script&lang=js&"
import style0 from "./FacilityBim.vue?vue&type=style&index=0&id=596be389&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596be389",
  null
  
)

export default component.exports